<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M1.5 10C1.5 5.3056 5.30557 1.5 10 1.5C14.6944 1.5 18.5 5.3056 18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30557 18.5 1.5 14.6944 1.5 10ZM10 0C4.47716 0 0 4.47717 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47717 15.5228 0 10 0ZM8.16656 6.50513L13.5752 10L8.16656 13.4949V6.50513ZM6.66656 16.25L16.339 10L6.66656 3.75V16.25Z"
			fill="black"
		/>
	</svg>

</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

